import { SCHEDULE_CONFIG as C } from './scheduleConfig';
import { renderTemplate } from './scheduleTemplates';
import { formatTime, formatLongDay, yearsLabel } from './dateUtils';
import { parseNotes, parseClientFromReason } from './scheduleNotes';
import { getPatientCard, buildAnketaButton } from './schedulePatient';
import * as DiagnosticTypes from '../diagnosticTypes/index.js';

/** Тип слота -> имя twig-шаблона */
export function getSlotType(info) {
    if (info.Reason === 'offDays') return 'offdays';
    if (info.ClientsCustomerID === null && info.ClientsStaffID === null && info.Reason === null) return 'free';
    if (info.ClientsCustomerID !== null && info.ClientsCustomerID !== '') {
        if (info.Type === 'BUSINESS') return 'busy';
        if (info.Type === 'PERSONAL') return 'block';
    }
    return null;
}

function getSalonCode(info, salons) {
    if (!info.SalonId) return '';
    return salons.find((s) => s.store_id == info.SalonId)?.store_cod ?? '';
}

function baseData(t, info, ctx) {
    const start = new Date(t).getTime();
    const end = start + C.SLOT_MINUTES * 60 * 1000;
    const passed = new Date() > new Date(t);
    return {
        unitId: ctx.unitId,
        staffID: ctx.staffId,
        doctorTimeStart: formatTime(start),
        doctorTimeEnd: formatTime(end),
        doctorTimestampStart: start,
        doctorTimestampEnd: end,
        orderDateDayToUser: formatLongDay(t),
        currentDoctorSalon: getSalonCode(info, ctx.salons),
        timePassed: passed ? 'time_passed' : '',
        timePassedDisabled: passed ? 'disabled="disabled"' : '',
    };
}

const extras = {
    offdays: () => ({}),

    free: (info, ctx) => ({
        salon_id: info.SalonId,
        currentDoctorInfoMinPatientAge: ctx.doctorInfo.MinPatientAge,
        currentDoctorInfoName: ctx.doctorInfo.Name,
        currentDoctorInfoStaffID: ctx.doctorInfo.StaffID,
    }),

    block: (info) => ({
        doctorScheduleInfoReason: info.Reason,
        doctorScheduleInfoID: info.ID,
    }),

    busy: (info, ctx) => {
        const notes = parseNotes(info.Notes);
        const manager = ctx.staffs[notes.manager];
        const managerName = manager
            ? manager.description.name
            : (notes.selfAppointment ? 'Самостоятельная Запись' : 'Не известно');

        const { name: clientName, phone: clientPhone } = parseClientFromReason(info.Reason);
        const [forFormName, forFormSurname] = clientName.split(' ');
        const patient = getPatientCard(info.ClientsCustomerID, ctx.patients);
        const approved = Boolean(info.IsApproved);

        return {
            managerName,
            clientName,
            clientPhone,
            clientAge: patient.age,
            yearsText: yearsLabel(patient.age),
            patientDateBirth: patient.birthText,
            forFormName,
            forFormSurname,
            goToDoc: buildAnketaButton(patient.lastAnketa),
            doctorScheduleComeFrom: notes.comeFrom,
            doctorScheduleComment: notes.comment,
            doctorScheduleCommentText: notes.comment ? 'myScheduleComment--active' : '',
            doctorScheduleVisit: notes.visit,
            doctorScheduleInfoID: info.ID,
            doctorScheduleInfoIsApproved: info.IsApproved,
            isApprovedText: approved ? 'да' : 'нет',
            statusDoctorClass: approved ? 'isApproved' : 'noApproved',
            switchStatus: approved ? 'checked' : '',
            orderStart: formatTime(info.Start),
            orderEnd: formatTime(info.Finish),
            diagnosticTypes: DiagnosticTypes.getDiagnosticTypes(),
        };
    },
};

/**
 * Строит html-строку слота.
 * ctx: { staffId, doctorInfo, staffs, salons, patients, unitId }
 */
export function buildRow(t, info, ctx) {
    const type = getSlotType(info);
    if (!type) return '';
    return renderTemplate(type, { ...baseData(t, info, ctx), ...extras[type](info, ctx) });
}
